import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

import "./sobreNos.css";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import Whatsapp from "../../components/whatsapp/whatsapp";
import SEO from "../../components/seo/SEO";
import { getBreadcrumbSchema } from "../../utils/schemas";

function SobreNos() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const breadcrumbs = [
    { name: "Home", url: "https://antoniosaldanhaadvocacia.com.br/" },
    {
      name: "Sobre Nós",
      url: "https://antoniosaldanhaadvocacia.com.br/sobre-nos",
    },
  ];

  return (
    <div className="container-fluid p-0 sobre-nos">
      <SEO
        title="Sobre Nós | Antonio Saldanha Advocacia"
        description="Conheça o compromisso, a filosofia e o atendimento humanizado do escritório Antonio Saldanha Advocacia."
        canonical="https://antoniosaldanhaadvocacia.com.br/sobre-nos"
        schemaJson={getBreadcrumbSchema(breadcrumbs)}
      />

      <Navbar />

      <main className="py-4">
        <section
          className="container mt-4 d-flex flex-column align-items-center"
          data-aos="fade-up"
        >
          <span className="badge badge-dourado mb-2">Quem Somos</span>
          <h1 className="titulos-secoes text-center">Sobre Nós</h1>

          <div className="sobre-nos-wrapper mt-4 bg-white p-4 p-md-5 rounded-3 shadow-sm border">
            <p className="texto-sobre-nos lead text-dark font-subtitulo mb-4">
              Nosso escritório de advocacia tem como principal compromisso
              oferecer um atendimento jurídico humanizado, eficiente e
              totalmente voltado às necessidades de cada cliente. Acreditamos
              que a advocacia vai muito além da solução de conflitos: ela
              envolve compreensão, escuta atenta e atuação estratégica para
              assegurar que cada cliente se sinta amparado e plenamente
              representado.
            </p>

            <p className="texto-sobre-nos text-secondary mb-4">
              Trabalhamos com responsabilidade, clareza e dedicação, buscando
              sempre a melhor alternativa para cada caso, seja por meio da
              prevenção de litígios, da orientação jurídica adequada ou da
              atuação firme e técnica. Nosso objetivo é proporcionar segurança,
              transparência e confiança, construindo com o cliente uma parceria
              sólida na busca pelos melhores resultados.
            </p>

            <p className="texto-sobre-nos text-secondary mb-4">
              Estamos à disposição para acompanhar cada etapa do processo,
              esclarecer dúvidas e oferecer um suporte completo, sempre pautados
              na ética e no respeito.
            </p>

            <div className="pt-3 border-top d-flex flex-wrap gap-3 justify-content-center">
              <a
                href="https://wa.me/5511954242066"
                target="_blank"
                rel="noopener noreferrer"
                className="btn botao-dourado"
              >
                Falar com um Advogado no WhatsApp
              </a>
              <Link to="/#contato" className="btn botao-escuro-padrao">
                Fale Conosco
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default SobreNos;
